import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/components/ProductComponents';
import TextOnImage from '@/components/ProductDetailComponents/TextOnImage';
import SwitchTabModule from '@/components/ProductDetailComponents/SwitchTabModule';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointRiverBase from '@/components/AppPoint/RiverBasePC';
import { SHOW_APP_POINT_SITES } from '@/constants';

const webpUrl = '/media/rivermini/pc/';
const { EFPic } = createEFPic(webpUrl);

export default function IndexDynamic() {
    const { gloproductlist, useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('riverminiportablepowerstation');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['au', 'uk', 'cn']);
    const appImgLocal = locale == 'sa' ? 'en' : getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const rminImgLocal = locale == 'sa' ? 'en' : getImageLocal(locale, ['cn']);
    const item1 = {
        title: t('river_mini.third_title'),
        synopsis: t('river_mini.third_subtitle'),
        desc: t('river_mini.third_des'),
        bgImgs: [`3_usage_${rminImgLocal}.webp`, `3_usage_${rminImgLocal}.jpg`],
    };

    const item2 = {
        title: t('river_mini.four_title'),
        synopsis: t('river_mini.four_subtitle'),
        noUseHtmlAttr: false,
        desc: t.rich('river_mini.four_des', {
            line1: (text: string) => (
                <Link className="ef-link__page" href="/x-boost" newWin>
                    {text}
                </Link>
            ),
        }),
        bgImgs: ['4_delta-pro-kv.webp', '4_delta-pro-kv.jpg'],
        phrase: t('river_mini.four_text'),
        arr: [
            { num: 300, eum: t('river_mini.four_unit'), phrase: t('river_mini.four_output') },
            { num: 600, eum: t('river_mini.four_unit'), phrase: t('river_mini.four_xboost') },
        ],
    };
    const switchTabData = [
        {
            tab: t('river_mini.five_wall_outlet_charging'),
            subTab: '',
            key: 'k1',
            videoUrl: '"/video/op.mp4"',
            imgUrl: ['8_switch_1.webp', '8_switch_1.jpg'],
            textTitle: t('river_mini.five_wall_outlet_charging_title'),
            textDesc: t('river_mini.five_wall_outlet_charging_des'),
            textSupliment: '',
            showVideo: false,
        },
        {
            tab: t('river_mini.five_solar_charging'),
            subTab: '',
            key: 'k2',
            videoUrl: '"/video/op.mp4"',
            imgUrl: [`8_switch_2_${imgLocal}.webp`, `8_switch_2_${imgLocal}.jpg`],
            textTitle: t('river_mini.five_solar_charging_title'),
            textDesc: t('river_mini.five_solar_charging_des'),
            textSupliment: '',
            showVideo: false,
        },
        {
            tab: t('river_mini.five_car_outlet_charging'),
            subTab: '',
            key: 'k3',
            videoUrl: '"/video/op.mp4"',
            imgUrl: ['8_switch_3.webp', '8_switch_3.jpg'],
            textTitle: t('river_mini.five_car_outlet_charging_title'),
            textDesc: t('river_mini.five_car_outlet_charging_des'),
            textSupliment: '',
            showVideo: false,
        },
    ];
    const textImageData = {
        title: t('river_mini.six_title'),
        synopsis: t('river_mini.six_subtitle'),
        desc: t('river_mini.six_des'),
        bgImgs: ['6_delta-pro-lg.webp', '6_delta-pro-lg.jpg'],
    };

    const textImageData2 = {
        title: t('river_mini.seven_title'),
        synopsis: t('river_mini.seven_subtitle'),
        desc: t('river_mini.seven_des'),
        bgImgs: [`7_cellphone_${appImgLocal}.webp`, `7_cellphone_${appImgLocal}.jpg`],
    };

    const titleFontSize = {
        us: 64,
        jp: 47,
        de: 56,
        fr: 55,
        es: 54,
    };

    return (
        <>
            <LineSpace height={180} background="transparent" />
            <div className="section2">
                <div className="top">
                    <div className="tl box">
                        <EFPic
                            name={['RIVER mini_web _01.webp', 'RIVER mini_web _01.png']}
                            alt={t('river_mini.ytdd_sec1_tit')}
                            aria-label={t('river_mini.ytdd_sec1_tit')}
                        />
                    </div>
                    <div className="tr box">
                        <div className="trt box">
                            <EFPic
                                name={['RIVER mini_web _04.webp', 'RIVER mini_web _04.png']}
                                alt={t('river_mini.ytdd_sec2-top_tit2')}
                                aria-label={t('river_mini.ytdd_sec2-top_tit2')}
                            />
                            <p className="tit">{t('river_mini.ytdd_sec2-top_tit2')}</p>
                        </div>
                        <div className="trb box">
                            <EFPic
                                name={['RIVER mini_web _05.webp', 'RIVER mini_web _05.png']}
                                alt={t('river_mini.ytdd_sec2-btm_tit')}
                                aria-label={t('river_mini.ytdd_sec2-btm_tit')}
                            />
                            <p className="tit">{t('river_mini.ytdd_sec2-btm_tit')}</p>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="bl box">
                        <EFPic
                            name={['RIVER mini_web _02.webp', 'RIVER mini_web _02.png']}
                            alt={t('river_mini.ytdd_sec4_tit1')}
                            aria-label={t('river_mini.ytdd_sec4_tit1')}
                        />
                        <p className="tit">{t('river_mini.ytdd_sec4_tit1')}</p>
                        <p className="num">{t('river_mini.ytdd_sec4_tit2')}</p>
                    </div>
                    <div className="bm box">
                        <EFPic
                            name={['RIVER mini_web _03.webp', 'RIVER mini_web _03.png']}
                            alt={t('river_mini.ytdd_sec3_tit2')}
                            aria-label={t('river_mini.ytdd_sec3_tit2')}
                        />
                        <p className="tit">{t('river_mini.ytdd_sec3_tit2')}</p>
                    </div>
                    <div className="br box">
                        <EFPic
                            name={['RIVER mini_web _06.webp', 'RIVER mini_web _06.png']}
                            alt={t('river_mini.ytdd_sec5_tit')}
                            aria-label={t('river_mini.ytdd_sec5_tit')}
                        />
                        <p className="tit">{t('river_mini.ytdd_sec5_tit')}</p>
                    </div>
                </div>
            </div>
            <LineSpace height={240} background="transparent" />
            <div className="textOnImg1">
                <TextOnImage
                    data={item1}
                    config={{
                        position: 'top',
                        descFontSize: locale === 'jp' ? 20 : 22,
                        width: locale === 'cn' ? '700px' : null,
                        webpUrl,
                    }}
                />
            </div>
            <LineSpace height={210} background="transparent" />
            <div className="textOnImg2">
                <TextOnImage
                    data={item2}
                    config={{
                        position: locale == 'sa' ? 'left' : 'right',
                        synopsisFontSize: titleFontSize[locale as keyof typeof titleFontSize] || titleFontSize.us,
                        webpUrl,
                        descFontSize: (() => {
                            const mapSize = {
                                fr: 20,
                                es: 20,
                            };
                            type Asmapsize = keyof typeof mapSize;
                            return mapSize[locale as Asmapsize] || 22;
                        })(),
                        synopsisLineHeight: locale === 'cn' ? '1.3' : '1.13',
                    }}
                />
            </div>
            <LineSpace height={180} background="transparent" />

            <div className="switchTab">
                <SwitchTabModule
                    data={switchTabData}
                    cssStyle={{
                        width: locale === 'cn' ? '1060px' : null,
                        webpUrl,
                    }}
                />
            </div>
            <LineSpace height={270} background="transparent" />

            <div className="textOnImg3">
                <TextOnImage
                    data={textImageData}
                    config={{
                        synopsisFontSize: locale === 'jp' ? 60 : 64,
                        titleFontSize: locale === 'jp' ? 23 : 26,
                        width: locale === 'cn' ? '500px' : null,
                        synopsisLineHeight: locale === 'cn' ? '1.3' : '1.13',
                        webpUrl,
                    }}
                />
            </div>

            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <>
                    <LineSpace height={120} background="transparent" />
                    <div className="textOnImg4">
                        <TextOnImage
                            data={textImageData2}
                            config={{
                                position: 'bottom',
                                synopsisFontSize: locale === 'fr' ? 58 : 64,
                                webpUrl,
                                descFontSize: (() => {
                                    const mapSize = {
                                        de: 20,
                                        es: 18,
                                    };
                                    type Asmapsize = keyof typeof mapSize;
                                    return mapSize[locale as Asmapsize] || 22;
                                })(),
                            }}
                        />
                    </div>
                </>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverBase />}
            <LineSpace height={270} background="transparent" />
            <OtherList
                data={getDetaileMoreProducts(gloproductlist, ['product_ps_river_river', 'product_ps_river_river_max', 'product_ps_river_river_pro_720'])}
            />
        </>
    );
}
